import { call } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
export function* fetchGroupFolders(groupId, folderType) {
    const params = {
        groupid: groupId,
        type: folderType
    };
    const result = yield call(requestPuppy, {
        method: 'get',
        url: 'group_folders',
        params
    }, ()=>{
        if (process.env.NODE_ENV !== 'production') {
            const collections = // eslint-disable-next-line global-require
            require('@wix/da-sample-data').collections;
            return {
                results: collections
            };
        }
        return {
            results: []
        };
    }, 'dadeviation');
    return result;
}
export function* addDeviationToGroupFolder(groupFolderId, deviationId) {
    const data = {
        groupid: groupFolderId.groupId,
        type: groupFolderId.type,
        folderid: groupFolderId.folderId,
        deviationid: deviationId
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'group_add',
        data
    }, ()=>{
        return {
            success: true
        };
    }, 'dadeviation') || {
        success: false
    };
    return result;
}

//# sourceMappingURL=xhr.js.map